module.exports = __webpack_public_path__ + "img/padlock.014ee5f8.svg";